import * as Yup from 'yup';

export const customerSchema = Yup.object().shape({
  companyName: Yup.string().nullable(true),
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  // phone: Yup.string()
  //   .required('Phone number is required')
  //   .matches(phoneRegExp, 'Phone number is not valid'),
  address: Yup.string().required('Address is required').nullable(),
  address2: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable(),
  zip: Yup.number().nullable(),
  notes: Yup.string(),
});
export const customerDefaultValues = {
  companyName: '',
  firstName: '',
  lastName: '',
  address: '',
  address2: '',
  // phone: undefined,
  city: '',
  state: '',
  zip: undefined,
  notes: '',
  tax_enabled: '',
  customerPhones: [
    {
      phone: '',
      default1: 'true',
    },
  ],
  customerEmails: [
    {
      email: '',
      default1: 'true',
    },
  ],
};

export const customerTypes = [
  {
    label: 'All Customers',
    value: 'all',
  },
  {
    label: 'First-Time Customer',
    value: '1',
  },
  {
    label: 'Repeat Customer',
    value: '2',
  },
];
